import { FC } from "react";
import styles from "./InfoMessageBar.module.scss";

export type InfoMessageType = "hight" | "mid" | "easy" | "aside";

interface InfoMessageBarProps {
  type: InfoMessageType;
  text: string;
}

export const InfoMessageBar: FC<InfoMessageBarProps> = ({ text, type }) => {
  const className: string = styles.messageBarWrapper + " " + styles[type];

  return (
    <div className={className}>
      <span>{text}</span>
    </div>
  );
};
